// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32FoK","content":"styles_content__2KUsS","tableWrap":"styles_tableWrap__gc1fi"};